import React from "react";
import PresetMenuItem from "./PresetMenuItem";
import {MenuItemStyleProps} from "components/DateRangeDropdown/types";

interface YearsMenuProps {
    selectedData: string;
    setSelectedData: (label: string) => void;
    menuItemStyle?: MenuItemStyleProps;
}

const YearsMenu: React.FC<YearsMenuProps> = ({ selectedData, setSelectedData, menuItemStyle }) => {
    return <PresetMenuItem category="Years" selectedData={selectedData} setSelectedData={setSelectedData} menuItemStyle={menuItemStyle} />;
};

export default YearsMenu;